function MessageTemplateForm({ templateName, setTemplateName, templateSubject, setTemplateSubject, templateContent, setTemplateContent, params, setParams, paramValues, setParamValues, onClick }) {

    return (
        <div style={{ minWidth: '40%'}}>
            <div className="form-group">
                <label>Template Name</label>
                <input
                    type="text"
                    className="form-control"
                    id="templateName"
                    placeholder="Enter template name"
                    value={templateName}
                    onChange={(e) => setTemplateName(e.target.value)}
                />
            </div>
            <div className="form-group">
                <label>Template Subject</label>
                <input
                    type="text"
                    className="form-control"
                    id="templateSubject"
                    placeholder="Enter template subject"
                    value={templateSubject}
                    onChange={(e) => setTemplateSubject(e.target.value)}
                />
            </div>
            <div className="form-group">
                <label>Template Content</label>
                <textarea
                    rows="30"
                    cols="100"
                    className="form-control"
                    id="templateContent"
                    value={templateContent}
                    onChange={(e) => setTemplateContent(e.target.value)}
                />
            </div>
            <div className="form-group">
                <label>Template Params</label>
                <input
                    className="form-control"
                    id="params"
                    value={params}
                    onChange={(e) => setParams(e.target.value)}
                />
            </div>
            <div className="form-group">
                <label>Param Value</label>
                <input
                    className="form-control"
                    id="paramValue"
                    value={paramValues}
                    onChange={(e) => setParamValues(e.target.value)}
                />
            </div>
            <button
                onClick={() => onClick()}
                className="btn btn-primary"
            >
                Submit
            </button>
        </div>
    )
}

export default MessageTemplateForm;